import branchallComponent from './branch.all.component';

let branchallModule = angular.module('branchall', [
])

.component('branchall', branchallComponent)

.name;

export default branchallModule;


// WEBPACK FOOTER //
// ./client/app/components/branch/all/index.js